import React, { useState, useEffect } from "react";
import NewsItems from "./NewsItems";
import PropTypes from "prop-types";
import axios from "axios";

const headerStyle = {
  fontFamily: "Rowdies",
  textAlign: "center",
  marginTop: "6rem",
  fontSize: "xxx-large",
};

const News = ({ country, category, headline }) => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [apiLimit, setApiLimit] = useState(false); // For Api Limit

  useEffect(() => {
    fetchArticles();
  }, [category, page]);

  const fetchArticles = async () => {
    const apiKey = process.env.REACT_APP_GNEWS_API_KEY;
    const url = `https://gnews.io/api/v4/top-headlines?country=${country}&topic=${category}&token=${apiKey}&page=${page}&lang=en`;

    try {
      setLoading(true);
      const response = await axios.get(url);

      if (response.data.totalArticles === 0) {
        // Check if no articles are returned
        setApiLimit(true);
      } else {
        setArticles(response.data.articles);
        setApiLimit(false); // Resetting apiLimit if articles are fetched
      }
    } catch (error) {
      setApiLimit(true);
      console.error("Error fetching data: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePrevious = () => {
    setPage(page - 1);
  };

  const handleNext = () => {
    setPage(page + 1);
  };

  return (
    <div>
      {apiLimit ? (
        <div
          style={{
            margin: "300px",
            textAlign: "center",
            border: "6px solid red",
          }}
        >
          <h1>API LIMIT REACHED</h1>
          <h4>Please Visit Tomorrow</h4>
        </div>
      ) : (
        <div>
          <h2 style={headerStyle} className="header text-center">
            {headline}
          </h2>
          <div className="container my-2">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <div>
                <div className="row">
                  {articles.map((article) => (
                    <div className="col-md-3" key={article.url}>
                      <NewsItems
                        title={article.title}
                        description={article.description.slice(0, 80)}
                        imageUrl={article.image}
                        newsUrl={article.url}
                        author={article.source?.name}
                        date={article.publishedAt}
                        source={article.source}
                      />
                    </div>
                  ))}
                </div>
                <div className="footerButtons d-flex justify-content-between">
                  <button
                    type="button"
                    onClick={handlePrevious}
                    className="btn btn-dark"
                    disabled={page === 1}
                  >
                    &larr; Previous
                  </button>
                  <button
                    type="button"
                    onClick={handleNext}
                    className="btn btn-dark"
                    disabled={articles.length === 0}
                  >
                    Next &rarr;
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

// Default Props
News.defaultProps = {
  country: "in",
  category: "general",
  headline: "Top Headlines",
};

// Prop Types
News.propTypes = {
  country: PropTypes.string,
  category: PropTypes.string,
  headline: PropTypes.string,
};

export default News;
